export default "__VITE_ASSET__DRxaYa1p__"